import { render, staticRenderFns } from "./ModalComplaint.vue?vue&type=template&id=cabb0084&"
import script from "./ModalComplaint.vue?vue&type=script&lang=js&"
export * from "./ModalComplaint.vue?vue&type=script&lang=js&"
import style0 from "./ModalComplaint.vue?vue&type=style&index=0&id=cabb0084&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports